module.exports = __webpack_public_path__ + "static/media/swiggy-logo.713d50ad.svg";